import React from "react";

function CatForm({ additionalAttributes, setAdditionalAttributes }) {
  const handleChange = (e) => {
    setAdditionalAttributes({
      ...additionalAttributes,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="catForm">
      {/* Cins seçimi */}
      <div>
        <h3>Pişik Cinsi <span>*</span></h3>
        <select name="catBreed" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Britan">Britan</option>
          <option value="Şotland">Şotland</option>
          <option value="Sfenks">Sfenks</option>
          <option value="İran">İran</option>
          <option value="Bengal">Bengal</option>
          <option value="Maine Coon">Maine Coon</option>
          <option value="Başqa">Başqa</option>
        </select>
      </div>

      {/* Yaş */}
      <div>
        <h3>Yaş (Ay və ya İl) <span>*</span></h3>
        <input type="number" name="age" min="0" max="20" required placeholder="Yaşı daxil edin" onChange={handleChange} />
      </div>

      {/* Cinsiyyət */}
      <div>
        <h3>Cinsiyyəti <span>*</span></h3>
        <select name="gender" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Erkək">Erkək</option>
          <option value="Dişi">Dişi</option>
        </select>
      </div>

      {/* Çəki */}
      <div>
        <h3>Çəki (kg) <span>*</span></h3>
        <input type="number" name="weight" min="0.5" max="15" step="0.1" required placeholder="Çəkini daxil edin" onChange={handleChange} />
      </div>

      {/* Rəng */}
      <div>
        <h3>Rəng <span>*</span></h3>
        <input type="text" name="color" required placeholder="Rəngi daxil edin" onChange={handleChange} />
      </div>

      {/* Sağlamlıq vəziyyəti */}
      <div>
        <h3>Sağlamlıq vəziyyəti <span>*</span></h3>
        <select name="healthStatus" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Sağlam">Sağlam</option>
          <option value="Müalicə olunmuş">Müalicə olunmuş</option>
          <option value="Xəstə">Xəstə</option>
          <option value="Peyvənd olunmuş">Peyvənd olunmuş</option>
        </select>
      </div>

      {/* Peyvəndlər */}
      <div>
        <h3>Peyvəndlər <span>*</span></h3>
        <select name="vaccinated" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>

      {/* Nəsil Şəcərəsi */}
      <div>
        <h3>Nəsil Şəcərəsi <span>*</span></h3>
        <select name="pedigree" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="true">Var</option>
          <option value="false">Yoxdur</option>
        </select>
      </div>

      {/* Aksesuarlar */}
      <div>
        <h3>Aksesuarlar daxildirmi? <span>*</span></h3>
        <select name="includesAccessories" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>

   
    </div>
  );
}

export default CatForm;
